import { format } from 'date-fns';

import { dateFormat } from 'constants/formats';
import { Eligible } from 'modules/transactions/pages/TenderOfferDetails/types/Eligible';
import { TranslateFn } from 'hooks/useTranslate';

export const buildIncentiveOfferEligiblesXlsxData = ({
  eligibles,
  t,
}: {
  eligibles: Eligible[];
  t: TranslateFn;
}) =>
  (eligibles || []).map((eligible, index) => ({
    '#': index + 1,
    [t('Name')]: eligible.name,
    [t('Email')]: eligible.email,
    [t('TotalVestShareUnits')]: eligible.totalUnits,
    [t('CanSell')]: eligible.maximumSaleUnits,
    '%ND': eligible.ndPercentage,
    '%FD': eligible.fdPercentage,
    [t('OfferAmount')]: eligible.offerAmount,
    [t('SharesUnitsSold')]: eligible.soldUnits,
    [t('SoldAmount')]: eligible.soldAmount,
    [t('StrikePrice')]: eligible.strikePrice,
    [t('RetentionPercentage')]: eligible.retentionPercentage,
    [t('NetAmount')]: eligible.netAmount,
    [t('SaleDate')]:
      eligible.saleDate instanceof Date
        ? format(eligible.saleDate, dateFormat)
        : '-',
    [t('Status')]: t(eligible.statusLabel),
    [t('Link')]: eligible.platformLink,
    [t('Canceled')]: eligible.isCanceled ? t('Yes') : t('Nope'),
  }));
